<template>
  <div>
    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbydateOptions && !loading">
            <apexchart
              ref="reportuserbydate"
              type="area"
              height="350"
              :options="reportuserbydateOptions"
              :series="reportuserbydateSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
// import StatCard from '@/components/view/dashboard/StatCard'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    // StatCard,
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },

  props: ['value', 'date', 'beaconSelect'],
  data() {
    return {
      total_all_user: null,
      reportuserbydateSeries: null,
      total_active_users: null,
      reportuserbydateOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: this.$t('active users')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      },
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const vm = this
      try {
        vm.loading = true
        const response = await beaconApi.getReportUserByDateBeaconsList({
          config: {
            pageid: vm.selectedBot.pageid,
            params: {
              from_date: dayjs(vm.date.start).format('YYYY-MM-DD'),
              to_date: dayjs(vm.date.end).format('YYYY-MM-DD')
            }
          }
        })

        handleResponse(response)

        await vm.$nextTick()
        vm.total_all_user = response.total_all_user
        vm.$emit('input', response.total_all_user)

        let rawdata = response.result
        if (vm.beaconSelect) {
          rawdata = rawdata.filter((item) => item.hwid === vm.beaconSelect.beacon_id)
        }
        let data = rawdata.map((el) => {
          return [
            dayjs(el.date_count, 'YYYY-MM-DDT00:00').utcOffset(0, true).valueOf(),
            parseInt(el.total_user)
          ]
        })
        vm.reportuserbydateSeries = [{ name: vm.$t('active users'), data: data }]

        let max = 0
        if (data && data.length > 0) {
          max = data.reduce((acc, val) => {
            acc = acc === undefined || val[1] > acc ? val[1] : acc
            return acc
          })
        }
        if (vm.$refs.reportuserbydate) {
          vm.$refs.reportuserbydate.updateOptions({
            yaxis: {
              max: max + 5
            }
          })
        }
        vm.$emit('onLoaded', { loading: false, data: vm.reportuserbydateSeries })
        vm.loading = false
      } catch (error) {
        vm.loading = false
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/ReportUserByDate.vue